var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InfoButton',{attrs:{"active":_vm.modalVisible,"disabled":_vm.disabled},on:{"click":function($event){return _vm.showModal(true)}}}),(_vm.modalVisible)?_c('InfoModal',{attrs:{"title":_vm.title},on:{"click":function($event){return _vm.showModal(false)}}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }